import Vue from 'vue';
import { MutationTree } from 'vuex';
import { OperatorModel } from '@/models/Operator';
import OperatorState from './state';
import { MutationTypes } from './mutation-types';

const mutations: MutationTree<OperatorState> = {
    [MutationTypes.LOAD](state: OperatorState, operators: OperatorModel[]) {
        for (const operator of operators) {
            Vue.set(state.operators, operator.sortOrder, operator);
        }
    },

    [MutationTypes.CHANGE_IS_TARGET_GROUPING](state: OperatorState, payload: { status: boolean, id: number }) {
        const targetOperator = state.operators.find((operator) => operator.id === payload.id);
        if (targetOperator) {
            targetOperator.isGroupingTarget = payload.status;
        }
    },

    [MutationTypes.CHANGE_SORT_ORDER](state: OperatorState, payload: { orderNo: number, id: number }) {
        const targetOperator = state.operators.find((operator) => operator.id === payload.id);
        if (targetOperator) {
            targetOperator.sortOrder = payload.orderNo;
        }
    },

    [MutationTypes.CHANGE_VISIBLE](state: OperatorState, payload: { status: boolean, id: number }) {
        const targetOperator = state.operators.find((operator) => operator.id === payload.id);
        if (targetOperator) {
            targetOperator.visible = payload.status;
        }
    },

    [MutationTypes.CHANGE_RUCRUIT_COST](state: OperatorState, payload: { cost: number, id: number }) {
        const targetOperator = state.operators.find((operator) => operator.id === payload.id);
        if (targetOperator) {
            targetOperator.recruitCost = payload.cost;
        }
    },
};

export default mutations;
